import { analytics, didNavigateFromDurationCarousel } from '~/common';

import type { Content } from '../../types';

import { getPercentageWatched } from './getPercentageWatched';
import { useNavigationState } from '../../../../hooks';
import { useMediaPlayer } from '../../../MediaPlayerProvider';
import { extractTeacher, extractTitle } from '../../content-utils';

export function useNavigateFromDurationCarouselAnalytics({ content }: { content: Content }) {
  const { player } = useMediaPlayer();
  const { navigationState } = useNavigationState();

  if (didNavigateFromDurationCarousel(navigationState)) {
    const viewedPercentage = getPercentageWatched({
      player,
    });
    const title = extractTitle(content);
    const teacher = extractTeacher(content);
    analytics.sendDurationCarouselClassViewed(`${viewedPercentage}%`, title, teacher.full_name);
  }
}
